export const getPagination = ({ pagination }) => pagination;
export const user_empty = () => ({
  nome: "",
  descricao: "",
  roles: [],
});
